import axios from 'axios';
import TokenService from './storage.service';
import { notifyError } from '../support/utils';

const ApiService = {


  init(baseURL) {
    axios.defaults.baseURL = baseURL;
  },

  async setHeader() {
    axios.defaults.headers.Authorization = `Bearer ${TokenService.getToken()}`;
  },

  removeHeader() {
    axios.defaults.headers.common = {};
  },

  get(resource) {
    return axios.get(resource).catch((error) => {
      notifyError(error.message);
    });
  },

  post(resource, data) {
    return axios.post(resource, data).catch((error) => {
      notifyError(error.message);
    });
  },

  put(resource, data) {
    return axios.put(resource, data);
  },

  delete(resource) {
    return axios.delete(resource);
  },

  customRequest(data) {
    return axios(data);
  },
  loginRequest(data) {
    return axios.post('https://broker360-identity-api.azurewebsites.net/connect/token', data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
  },
};

export default ApiService;
